






























import { Prop, VModel, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";
import _ from "lodash";
import { format } from "date-fns";
import { humanFileSize } from "@/constants";

@Component
export default class FileTextBoxSearch extends Vue {
  items = [];
  loading = false;
  @VModel() selectFile;
  search = null;
  placeholder = 'Gõ để tìm kiếm';
  label = 'Chọn file';
  limit = 5;

  @Prop() projectIdSearch;

  searchFn = undefined;

  dateTime(item) {
    return this.formatDateTime(item.createdDate);
  }

  formatDateTime(date) {
    const d = new Date(date);
    return format(d, 'dd/MM/yyyy HH:mm:ss');
  }

  humanSize(item) {
    return humanFileSize(item.fileSize);
  }

  mounted() {
    const vm = this;
    this.searchFn = _.debounce(async function (newSearchVal) {
      if (vm.loading) return;
      vm.loading = true;

      let fileGeodeticService = new FileGeodeticService();
      try {
        let rs = await fileGeodeticService.search({ page: 0, size: vm.limit }, newSearchVal, vm.projectIdSearch);
        vm.items = rs.data;
      } finally {
        vm.loading = false;
      }
    }, 500);
    this.searchFn('');
  }

  @Watch('search')
  async onSearchChange(newSearchVal) {
    this.searchFn(newSearchVal);
  }

  getImgThumbnailUrl(item) {
    const fileGeodeticService = new FileGeodeticService();
    return fileGeodeticService.thumbnail(item.id);
  }

  @Watch('projectIdSearch')
  onProjectIdSearchChange(val, oldVal) {
    this.searchFn('');
  }
}
